"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UserBgCollapse = function UserBgCollapse(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#ffffff' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, ".cls-2{fill:".concat(color, "}"))), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.88 9.81c-.83 0-1.51.68-1.51 1.51s.68 1.51 1.52 1.5c.82 0 1.51-.69 1.5-1.51 0-.83-.68-1.5-1.51-1.5Z",
    style: {
      fill: 'none'
    },
    color: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M16.9 1.62c-4.33.02-8.65.02-12.98 0-.73 0-1.35.64-1.35 1.34v5.98c0-.22.18-.4.4-.4s.4.18.4.4v.01-5.88c0-.49.16-.65.65-.65h12.77c.49 0 .65.16.65.65v12.82c0 .48-.16.64-.64.64h-5.57c.21.01.38.18.38.39s-.18.4-.4.4H16.97c.3-.09.24.01.44-.09.52-.19.81-.63.81-1.2V2.95c0-.66-.59-1.33-1.34-1.32ZM2.58 8.95v-.01Z",
    color: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M16.98 17.31c.16.02.3 0 .44-.09-.37.15-.03-.12-.44.09ZM5.85 4.34l-.15-.15c-.21-.2-.45-.22-.62-.05-.16.16-.14.4.05.6.53.54 1.07 1.07 1.6 1.61.08.08.15.16.26.27h-.26c-.42-.02-.83-.04-1.25-.05-.25 0-.42.17-.42.4s.14.38.4.39c.83.04 1.67.07 2.5.09.27 0 .43-.14.43-.39-.02-.87-.06-1.74-.09-2.6 0-.21-.14-.33-.36-.34-.23-.01-.36.11-.41.32-.02.1 0 .21 0 .31v1.27L5.86 4.35ZM12.51 14.5c.01.22.17.33.39.33.24 0 .38-.18.38-.46v-1.48c.09.11.14.19.2.25.54.54 1.08 1.09 1.62 1.62.22.22.51.21.65-.01.13-.21.07-.39-.1-.56-.55-.54-1.09-1.09-1.64-1.64-.06-.06-.14-.11-.16-.22h.25c.4.02.8.04 1.2.05.26 0 .43-.16.43-.39 0-.22-.13-.38-.36-.39-.85-.04-1.7-.07-2.55-.09-.25 0-.41.14-.41.38.02.88.05 1.75.09 2.63ZM13.29 4.56c0-.26-.16-.43-.39-.43s-.38.13-.39.39c-.04.84-.07 1.68-.09 2.53 0 .26.14.43.39.42.87-.02 1.74-.06 2.6-.1.18 0 .28-.13.32-.29a.37.37 0 0 0-.16-.41c-.11-.08-.24-.08-.38-.07l-1.32.06c-.02-.03-.03-.05-.05-.08.37-.36.75-.72 1.12-1.08.26-.26.52-.51.77-.78.15-.16.15-.4.01-.54-.15-.16-.38-.17-.56-.02-.05.04-.1.1-.15.14l-1.55 1.55c-.06.06-.11.16-.23.16v-.22c.02-.41.04-.82.05-1.22Z",
    color: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.91 13.4c-.19-.1-.39-.18-.6-.28 1.25-1.04 1.01-2.7.14-3.51-.88-.81-2.28-.81-3.15 0-.88.81-1.12 2.46.14 3.51-.17.07-.33.13-.48.21-.83.41-1.48 1.02-1.93 1.83-.36.65-.55 1.35-.54 2.1 0 .1.04.21.1.29.1.14.29.17.45.11.15-.06.25-.21.25-.38 0-.57.13-1.11.39-1.61.73-1.42 2.24-2.17 3.82-1.91 1.45.24 2.65 1.42 2.9 2.86.04.22.04.44.06.66.01.2.12.34.28.4.16.05.34 0 .44-.14.05-.08.08-.19.08-.28 0-.53-.09-1.03-.28-1.52-.4-1.03-1.1-1.8-2.07-2.32Zm-2.02-.58c-.83 0-1.51-.67-1.52-1.5 0-.83.68-1.51 1.51-1.51.82 0 1.5.68 1.51 1.5 0 .82-.68 1.51-1.5 1.51Z",
    color: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M2.97 8.54c-.22 0-.4.18-.4.4v.01c0 .21.18.38.39.38s.39-.17.39-.38v-.01c0-.22-.18-.4-.4-.4ZM11.62 16.93c0-.21-.17-.38-.38-.39h-.02c-.22 0-.4.18-.4.4s.18.4.4.4c.22 0 .4-.18.4-.4Z",
    color: color
  }));
};
var _default = exports["default"] = UserBgCollapse;